module.exports = __webpack_public_path__ + "media/images/fb-only-letter-fc39535889adb29aec1417f58c062ab6.svg";